import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { TIPO_LABELS } from '../data/orientaciones';

export function generarReportePDF(casos) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const hoy = format(new Date(), "dd 'de' MMMM 'de' yyyy", { locale: es });
  const fechaArchivo = format(new Date(), 'yyyy-MM-dd');
  const W = doc.internal.pageSize.getWidth();
  const AZUL = [0,45,98], ROJO = [206,17,38], VERDE = [0,154,68], BLANCO = [255,255,255], GRIS = [107,114,128], GRIS_CLARO = [249,250,251];

  doc.setFillColor(...AZUL); doc.rect(0, 0, W, 22, 'F');
  doc.setFillColor(...ROJO); doc.rect(0, 22, W, 2.5, 'F');
  doc.setFillColor(255,255,255); doc.rect(0, 24.5, W, 2.5, 'F');
  doc.setFillColor(...VERDE); doc.rect(0, 27, W, 2.5, 'F');

  doc.setTextColor(...BLANCO); doc.setFontSize(13); doc.setFont('helvetica','bold');
  doc.text('MINISTERIO DE EDUCACIÓN DE LA REPÚBLICA DOMINICANA', W/2, 9, { align: 'center' });
  doc.setFontSize(9); doc.setFont('helvetica','normal');
  doc.text('Dirección de Acreditación de Centros Educativos — DACE', W/2, 14, { align: 'center' });
  doc.text('Distrito Educativo 1102 — Puerto Plata', W/2, 19, { align: 'center' });

  doc.setTextColor(...AZUL); doc.setFontSize(14); doc.setFont('helvetica','bold');
  doc.text('REPORTE DE CASOS — INSTITUCIONES EDUCATIVAS PRIVADAS', W/2, 40, { align: 'center' });
  doc.setFontSize(10); doc.setFont('helvetica','normal'); doc.setTextColor(...GRIS);
  doc.text(`Fecha de generación: ${hoy}`, W/2, 47, { align: 'center' });

  const total = casos.length;
  const stats = [
    { label: 'Total', value: total, color: AZUL },
    { label: 'Recibidos', value: casos.filter(c=>c.estado==='Recibido').length, color: [29,78,216] },
    { label: 'En proceso', value: casos.filter(c=>c.estado==='En proceso').length, color: [180,83,9] },
    { label: 'Orientados', value: casos.filter(c=>c.estado==='Orientado').length, color: [21,128,61] },
    { label: 'Cerrados', value: casos.filter(c=>c.estado==='Cerrado').length, color: [107,114,128] },
  ];
  const cW = (W-30)/5;
  stats.forEach((s,i) => {
    const x = 15 + i*cW;
    doc.setFillColor(...s.color); doc.roundedRect(x, 52, cW-3, 18, 2, 2, 'F');
    doc.setTextColor(...BLANCO); doc.setFontSize(18); doc.setFont('helvetica','bold');
    doc.text(String(s.value), x+(cW-3)/2, 62, { align: 'center' });
    doc.setFontSize(7); doc.setFont('helvetica','normal');
    doc.text(s.label, x+(cW-3)/2, 67, { align: 'center' });
  });

  autoTable(doc, {
    startY: 76,
    head: [['#','Código','Centro Educativo','Tipo de Caso','Solicitante','Enviado a','Estado','Fecha']],
    body: casos.map((c,i) => [i+1, c.codigoCentro||'—', c.centro||'—', TIPO_LABELS[c.tipo]||c.tipo||'—', c.solicitante||'—', c.destinatario||'—', c.estado||'—', c.fecha||'—']),
    headStyles: { fillColor: AZUL, textColor: BLANCO, fontStyle: 'bold', fontSize: 8, halign: 'center' },
    bodyStyles: { fontSize: 7.5, textColor: [31,41,55] },
    alternateRowStyles: { fillColor: GRIS_CLARO },
    columnStyles: { 0:{halign:'center',cellWidth:8}, 1:{halign:'center',cellWidth:18}, 2:{cellWidth:55}, 3:{cellWidth:38}, 4:{cellWidth:35}, 5:{cellWidth:40}, 6:{halign:'center',cellWidth:22}, 7:{halign:'center',cellWidth:22} },
    didParseCell(data) {
      if (data.section==='body' && data.column.index===6) {
        const e = data.cell.raw;
        data.cell.styles.textColor = e==='Recibido'?[29,78,216]:e==='En proceso'?[180,83,9]:e==='Orientado'?[21,128,61]:[107,114,128];
        data.cell.styles.fontStyle = 'bold';
      }
    },
    margin: { left: 15, right: 15 },
  });

  const totalPages = doc.getNumberOfPages();
  for (let i=1; i<=totalPages; i++) {
    doc.setPage(i);
    const pH = doc.internal.pageSize.getHeight();
    doc.setFillColor(...AZUL); doc.rect(0, pH-12, W, 12, 'F');
    doc.setTextColor(...BLANCO); doc.setFontSize(7); doc.setFont('helvetica','normal');
    doc.text('GestorPrivadas — Distrito 1102 Puerto Plata · MINERD', 15, pH-5);
    doc.text(`Página ${i} de ${totalPages} · Ordenanza 4-2000`, W-15, pH-5, { align: 'right' });
  }
  doc.save(`Reporte_Casos_Distrito1102_${fechaArchivo}.pdf`);
}
